module.exports = __webpack_public_path__ + "static/media/trophy-cup.f8c17174.png";